export default __webpack_public_path__ + "static/media/globe.2121c948.svg";